import { AwsUi } from '../../../core/runtime/src';
import { ExpandableSection } from '../../expandable-section/src';
export var FormSection = AwsUi.__addComponent('awsui-form-section', {
    releaseStatus: 'stable',
    properties: {
        // Indicates whether the section should be expandable.
        // Expandable sections are supposed to contain additional optional settings.
        expandable: {
            type: 'boolean'
        },
        // Indicates whether the section is expanded or not
        expanded: {
            type: 'boolean'
        }
    },
    regions: {
        // Rendered inside the form section.
        content: {
            isDefault: true
        },
        // Title of the form section (mandatory).
        header: {},
        // General description about the form section (optional).
        description: {},
        // Footer of the form section. This is where additional settings are supposed to be placed.
        // Please check the borderless variant of expandable sections for further information.
        // If the `expandable` property is set to true, the content of this region will be ignored.
        footer: {}
    },
    events: {
        // Fired when the state of the expandable form section changes (collapsed or expanded).
        // The event `detail`contains the current value of the `expanded` property.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'FormSection.ChangeDetail'
        }
    },
    render: function (m, h) {
        var _this = this;
        var header = (AwsUi.__createElement("div", null,
            h.region('header'),
            h.region('description', 'div', { className: 'awsui-util-container-header-description' })));
        var content = h.region('content');
        var expandableSection = function () {
            var changeHandler = function (evt) {
                evt.stopPropagation();
                _this.expanded = !_this.expanded;
                _this.__fireEvent('change', { expanded: _this.expanded });
            };
            return (AwsUi.__createElement(ExpandableSection, { variant: "container", header: header, content: content, expanded: _this.expanded, change: changeHandler }));
        };
        var defaultSection = function () { return (AwsUi.__createElement("div", { className: "awsui-util-container" },
            AwsUi.__createElement("div", { className: "awsui-util-container-header" }, header),
            content,
            h.region('footer', 'div', { className: 'awsui-util-container-footer' }))); };
        return this.expandable ? expandableSection() : defaultSection();
    }
});
//# sourceMappingURL=form-section.js.map